import {
  FileMultipleStroke,
  Pencil1Stroke,
  PlusStroke,
  PrinterStroke,
  Search1Stroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import { TEMPLATE_BASE64 as excelTemplate_ban_hang_hoa_don_ban_ra_hoa_don_ban_hang_H_a___n_b_n_h_ng } from '@/lib/templates-base64/HDBH';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
import { useHoaDonBanHangSearchContext } from '../context/index';
import { downloadBase64Excel } from '@/lib/template-downloader';

interface ActionBarProps {
  onAdd?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onCopy?: () => void;
  onPrint?: () => void;
  onSearch?: () => void;
  onRefresh?: () => void;
  onImportExcel?: () => void;
  isEditDisabled?: boolean;
}

export default function ActionBar({
  onAdd,
  onEdit,
  onDelete,
  onCopy,
  onPrint,
  onSearch,
  onRefresh,
  onImportExcel,
  isEditDisabled = true
}: ActionBarProps) {
  const { exportToExcel, canExport, isExporting } = useHoaDonBanHangSearchContext();

  const handleDownloadExcelTemplate = () => {
    downloadBase64Excel(
      excelTemplate_ban_hang_hoa_don_ban_ra_hoa_don_ban_hang_H_a___n_b_n_h_ng,
      'Hóa đơn bán hàng.xlsx'
    );
  };

  return (
    <ActionBarV2 title='Hóa đơn bán hàng'>
      <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAdd} />
      <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEdit} disabled={isEditDisabled} />
      <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={onDelete} disabled={isEditDisabled} />
      <ActionButtonV2 icon={FileMultipleStroke} title='Sao chép' onClick={onCopy} disabled={isEditDisabled} />
      <ActionButtonV2 icon={PrinterStroke} title='In ấn' onClick={onPrint} />
      <ActionButtonV2 icon={Search1Stroke} title='Tìm kiếm' onClick={onSearch} />

      <MenuButtonV2
        items={[
          {
            title: 'Refresh',
            icon: <AritoIcon icon={15} />,
            onClick: onRefresh,
            group: 1
          },
          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={16} />,
            onClick: () => {},
            group: 1
          },
          {
            title: 'In nhiều',
            icon: <AritoIcon icon={883} />,
            onClick: () => {},
            group: 2
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={555} />,
            onClick: exportToExcel,
            disabled: !canExport || isExporting,
            loading: isExporting,
            loadingTitle: 'Đang kết xuất...',
            group: 2
          },
          {
            title: 'Tải mẫu Excel',
            icon: <AritoIcon icon={28} />,
            onClick: handleDownloadExcelTemplate,
            group: 3
          },
          {
            title: 'Lấy dữ liệu từ Excel',
            icon: <AritoIcon icon={29} />,
            onClick: onImportExcel,
            group: 3
          }
        ]}
      />
    </ActionBarV2>
  );
}
